"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tertiaryButton = exports.secondaryButton = exports.primaryButton = exports.outlineButton = exports.defaultButton = exports.ctalinkWithArrow = exports.ctalink = void 0;
var _theme = _interopRequireDefault(require("./../../scss/theme.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  defaultButton = () => {
    return {
      backgroundColor: _theme.default.button_background_color,
      border: _theme.default.button_border,
      borderRadius: _theme.default.button_border_radius,
      color: _theme.default.button_color,
      fontFamily: _theme.default.button_font_family,
      fontSize: _theme.default.button_font_size,
      letterSpacing: _theme.default.button_font_letter_spacing,
      lineHeight: _theme.default.button_line_height,
      margin: _theme.default.button_margin,
      minHeight: _theme.default.button_min_height,
      minWidth: _theme.default.button_min_width,
      padding: _theme.default.button_padding,
      textAlign: _theme.default.button_text_align,
      textDecoration: _theme.default.button_text_decoration,
      textTransform: _theme.default.button_text_transform,
      "@media (hover: none)": {
        "&:hover": {
          backgroundColor: _theme.default.button_background_color
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: _theme.default.button_background_color_hover,
          color: _theme.default.button_color_hover,
          textDecoration: _theme.default.button_text_decoration
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: _theme.default.button_background_color_focus,
        borderColor: _theme.default.button_color_focus,
        boxShadow: "unset",
        color: _theme.default.button_color_focus,
        outline: "unset",
        outlineOffset: "unset",
        textDecoration: _theme.default.button_text_decoration
      },
      "&:disabled": {
        backgroundColor: _theme.default.button_background_color,
        color: _theme.default.button_color
      }
    };
  },
  primaryButton = () => {
    return merge(defaultButton(), {
      backgroundColor: _theme.default.button_primary_background_color,
      borderColor: _theme.default.button_primary_border_color,
      color: _theme.default.button_primary_color,
      "@media (hover: none)": {
        "&:hover": {
          backgroundColor: _theme.default.button_primary_background_color,
          borderColor: _theme.default.button_primary_border_color,
          color: _theme.default.button_primary_color
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: _theme.default.button_primary_background_color_hover,
          borderColor: _theme.default.button_primary_border_color_hover,
          color: _theme.default.button_primary_color_hover
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: _theme.default.button_primary_background_color_focus,
        borderColor: _theme.default.button_primary_border_color_focus,
        color: _theme.default.button_primary_color_focus
      },
      "&:disabled": {
        backgroundColor: _theme.default.button_primary_background_color_disabled,
        borderColor: _theme.default.button_primary_border_color_disabled,
        color: _theme.default.button_primary_color_disabled
      }
    });
  },
  secondaryButton = () => {
    return merge(defaultButton(), {
      backgroundColor: _theme.default.button_secondary_background_color,
      borderColor: _theme.default.button_secondary_border_color,
      color: _theme.default.button_secondary_color,
      "@media (hover: none)": {
        "&:hover": {
          backgroundColor: _theme.default.button_secondary_background_color,
          borderColor: _theme.default.button_secondary_border_color,
          color: _theme.default.button_secondary_color
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: _theme.default.button_secondary_background_color_hover,
          borderColor: _theme.default.button_secondary_border_color_hover,
          color: _theme.default.button_secondary_color_hover
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: _theme.default.button_secondary_background_color_focus,
        borderColor: _theme.default.button_secondary_border_color_focus,
        color: _theme.default.button_secondary_color_focus
      },
      "&:disabled": {
        backgroundColor: _theme.default.button_secondary_background_color_disabled,
        borderColor: _theme.default.button_secondary_border_color_disabled,
        color: _theme.default.button_secondary_color_disabled
      }
    });
  },
  outlineButton = () => {
    return merge(defaultButton(), {
      backgroundColor: _theme.default.button_outline_background_color,
      borderColor: _theme.default.button_outline_border_color,
      color: _theme.default.button_outline_color,
      "@media (hover: none)": {
        "&:hover": {
          backgroundColor: _theme.default.button_outline_background_color,
          borderColor: _theme.default.button_outline_border_color,
          color: _theme.default.button_outline_color
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: _theme.default.button_outline_background_color_hover,
          borderColor: _theme.default.button_outline_border_color_hover,
          color: _theme.default.button_outline_color_hover
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: _theme.default.button_outline_background_color_focus,
        borderColor: _theme.default.button_outline_border_color_focus,
        color: _theme.default.button_outline_color_focus
      },
      "&:disabled": {
        backgroundColor: _theme.default.button_outline_background_color_disabled,
        borderColor: _theme.default.button_outline_border_color_disabled,
        color: _theme.default.button_outline_color_disabled
      }
    });
  },
  tertiaryButton = () => {
    return merge(defaultButton(), {
      backgroundColor: _theme.default.button_tertiary_background_color,
      borderColor: _theme.default.button_tertiary_border_color,
      color: _theme.default.button_tertiary_color,
      "@media (hover: none)": {
        "&:hover": {
          backgroundColor: _theme.default.button_tertiary_background_color,
          borderColor: _theme.default.button_tertiary_border_color,
          color: _theme.default.button_tertiary_color
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: _theme.default.button_tertiary_background_color_hover,
          borderColor: _theme.default.button_tertiary_border_color_hover,
          color: _theme.default.button_tertiary_color_hover
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: _theme.default.button_tertiary_background_color_focus,
        borderColor: _theme.default.button_tertiary_border_color_focus,
        color: _theme.default.button_tertiary_color_focus
      },
      "&:disabled": {
        backgroundColor: _theme.default.button_tertiary_background_color_disabled,
        borderColor: _theme.default.button_tertiary_border_color_disabled,
        color: _theme.default.button_tertiary_color_disabled
      }
    });
  },
  ctalink = () => {
    return {
      alignItems: _theme.default.button_cta_link_align_items,
      background: _theme.default.button_cta_link_background_color,
      borderRadius: "0",
      color: _theme.default.button_cta_link_color,
      display: _theme.default.button_cta_link_display,
      fontFamily: _theme.default.button_cta_link_font_family,
      fontSize: _theme.default.button_cta_link_font_size,
      justifyContent: _theme.default.button_cta_link_justify_content,
      letterSpacing: _theme.default.button_cta_link_letter_spacing,
      lineHeight: _theme.default.button_cta_link_line_height,
      margin: _theme.default.button_cta_link_margin,
      padding: _theme.default.button_cta_link_padding,
      textAlign: _theme.default.button_cta_link_text_align,
      textDecoration: _theme.default.button_cta_link_text_decoration,
      textTransform: _theme.default.button_cta_link_text_transform,
      "@media (hover: none)": {
        "&:hover": {
          background: _theme.default.button_cta_link_background_color
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          background: _theme.default.button_cta_link_background_color,
          fontFamily: _theme.default.button_cta_link_font_family_hover,
          textDecoration: _theme.default.button_cta_link_text_decoration_hover
        }
      },
      "&:active,&:focus-visible": {
        background: _theme.default.button_cta_link_background_color,
        fontFamily: _theme.default.button_cta_link_font_family_hover,
        textDecoration: _theme.default.button_cta_link_text_decoration_hover
      }
    };
  },
  ctalinkWithArrow = () => {
    return merge(ctalink(), {
      "&::after": {
        backgroundImage: _theme.default.button_cta_link_with_arrow_background_image,
        backgroundPosition: _theme.default.button_cta_link_with_arrow_background_position,
        backgrounRepeat: _theme.default.button_cta_link_with_arrow_background_repeat,
        backgroundSize: _theme.default.button_cta_link_with_arrow_background_size,
        content: _theme.default.button_cta_link_with_arrow_content,
        display: _theme.default.button_cta_link_with_arrow_display,
        height: _theme.default.button_cta_link_with_arrow_height,
        margin: _theme.default.button_cta_link_with_arrow_margin,
        width: _theme.default.button_cta_link_with_arrow_width
      }
    });
  };
exports.ctalinkWithArrow = ctalinkWithArrow;
exports.ctalink = ctalink;
exports.tertiaryButton = tertiaryButton;
exports.outlineButton = outlineButton;
exports.secondaryButton = secondaryButton;
exports.primaryButton = primaryButton;
exports.defaultButton = defaultButton;